// src/theme/index.js

// Palette de couleurs principale
export const colors = {
  // Couleurs primaires
  bluePrimary: '#1E6CBB',        // Bleu ciel foncé
  orangeAccent: '#E85D04',       // Orange foncé
  greenSuccess: '#2B9348',       // Vert
  
  // Couleurs de mode nuit
  blueNight: '#0F1C3F',          // Bleu nuit
  gold: '#FFB800',               // Or
  skyBlue: '#4A90E2',            // Bleu ciel
  
  // Couleurs neutres
  white: '#FFFFFF',
  offWhite: '#F9F9F9',
  lightGrey: '#F5F5F5',
  mediumGrey: '#E0E0E0',
  darkGrey: '#333333',
  black: '#121212',
  
  // Couleurs de texte
  textDark: '#212529',
  textLight: '#F8F9FA',
  
  // Couleurs d'état
  error: '#E63946',
  warning: '#F4A261',
  info: '#457B9D'
};

// Thème clair - bleu ciel foncé, orange foncé, blanc et vert
export const lightTheme = {
  // Couleurs de fond - rendues plus transparentes
  background: 'rgba(255, 255, 255, 0.7)',
  backgroundSecondary: 'rgba(245, 245, 245, 0.7)',
  backgroundHover: 'rgba(30, 108, 187, 0.05)',
  
  // Couleurs de texte
  text: colors.textDark,
  textSecondary: '#4A5568',
  textMuted: '#718096',
  
  // Couleurs principales
  primary: colors.bluePrimary,
  accent: colors.orangeAccent,
  success: colors.greenSuccess,
  error: colors.error,
  warning: colors.warning,
  info: colors.info,
  
  // Couleurs des boutons
  buttonBg: 'rgba(30, 108, 187, 0.1)',
  buttonText: colors.bluePrimary,
  buttonHoverBg: colors.bluePrimary,
  buttonHoverText: colors.white,
  
  // Borders
  border: 'rgba(224, 224, 224, 0.7)',
  borderLight: 'rgba(245, 245, 245, 0.7)',
  
  // Shadows
  shadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
  shadowLarge: '0 10px 25px rgba(0, 0, 0, 0.1)',
  
  // Cards - rendues plus transparentes
  card: {
    background: 'rgba(255, 255, 255, 0.75)',
    shadow: '0 4px 8px rgba(0, 0, 0, 0.08)',
    hover: '0 6px 12px rgba(0, 0, 0, 0.12)'
  },
  
  // Statuts spécifiques
  active: {
    background: 'rgba(30, 108, 187, 0.1)',
    text: colors.bluePrimary
  },
  
  // Gradients
  gradient: {
    primary: 'linear-gradient(to right, rgba(30, 108, 187, 0.8), rgba(74, 144, 226, 0.8))',
    accent: 'linear-gradient(to right, rgba(232, 93, 4, 0.8), rgba(244, 140, 6, 0.8))'
  },
  
  // Spécifique pour le Header/Footer
  header: {
    background: 'rgba(255, 255, 255, 0.75)',
    text: colors.textDark,
    shadow: '0 2px 10px rgba(0, 0, 0, 0.06)'
  },
  
  footer: {
    background: 'rgba(248, 250, 252, 0.75)',
    text: colors.textDark
  }
};

// Thème sombre - bleu nuit pour le fond, or pour les boutons, bleu ciel et blanc
export const darkTheme = {
  // Couleurs de fond - rendues plus transparentes
  background: 'rgba(15, 28, 63, 0.65)',
  backgroundSecondary: 'rgba(15, 28, 63, 0.6)',
  backgroundHover: 'rgba(15, 28, 63, 0.65)',
  
  // Couleurs de texte
  text: colors.textLight,
  textSecondary: '#CDD5E1',
  textMuted: '#A0AEC0',
  
  // Couleurs principales
  primary: colors.skyBlue,
  accent: colors.gold,
  success: colors.greenSuccess,
  error: colors.error,
  warning: colors.warning,
  info: colors.info,
  
  // Couleurs des boutons
  buttonBg: 'rgba(255, 184, 0, 0.2)',
  buttonText: colors.gold,
  buttonHoverBg: colors.gold,
  buttonHoverText: colors.blueNight,
  
  // Borders
  border: 'rgba(255, 255, 255, 0.1)',
  borderLight: 'rgba(255, 255, 255, 0.05)',
  
  // Shadows
  shadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
  shadowLarge: '0 10px 25px rgba(0, 0, 0, 0.3)',
  
  // Cards - rendues plus transparentes
  card: {
    background: 'rgba(15, 28, 63, 0.6)',
    shadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    hover: '0 6px 12px rgba(0, 0, 0, 0.35)'
  },
  
  // Statuts spécifiques
  active: {
    background: 'rgba(74, 144, 226, 0.2)',
    text: colors.skyBlue
  },
  
  // Gradients
  gradient: {
    primary: 'linear-gradient(to right, rgba(15, 28, 63, 0.8), rgba(30, 108, 187, 0.8))',
    accent: 'linear-gradient(to right, rgba(232, 93, 4, 0.8), rgba(255, 184, 0, 0.8))'
  },
  
  // Spécifique pour le Header/Footer
  header: {
    background: 'rgba(15, 28, 63, 0.75)',
    text: colors.textLight,
    shadow: '0 2px 10px rgba(0, 0, 0, 0.2)'
  },
  
  footer: {
    background: '#0d1b2a',
    text: colors.textLight
  }
};